import { useState } from 'react';
import { connect } from 'react-redux';

import { ReactComponent as CancelIcon } from './../../../../assets/svg/cancel.svg';
import { ReactComponent as FilterIcon } from './../../../../assets/svg/filter.svg';
import { ReactComponent as SortIcon } from './../../../../assets/svg/sort.svg';
import FilterSidebar from './FilterSidebar/FilterSidebar';
import SortModal from './SortModal/SortModal';
import useFilter from './useFilter';
import useSort from './useSort';

const FilterSort = ({ city_id, category_id }) => {
  const [filter_open, set_filter_open] = useState(false);

  const [
    filter_list,
    set_filter_list,
    checkbox_change,
    clear_filter,
    submit_filter,
    current_filters,
    delete_filter
  ] = useFilter(city_id, category_id, set_filter_open);

  const [sort_modal, set_sort_modal, active_sort, set_active_sort, sort_list] = useSort();

  return (
    <div className="filter-sort-container">
      <div className="filter-container">
        <div className="filter-container-filter-button">
          <button
            className="filter-button"
            onClick={() => set_filter_open(!filter_open)}
            type="button">
            <span>فیلتر</span>
            <FilterIcon />
          </button>
        </div>
        <div className="filter-container-sort-button">
          <button className="sort-button" onClick={() => set_sort_modal(true)} type="button">
            <div>
              <span>
                مرتب سازی: {sort_list.find((sort_item) => sort_item.key === active_sort).label}
              </span>
            </div>
            <SortIcon />
          </button>
        </div>
      </div>
      <div className="current-filters-container">
        {current_filters.map((filter_item) => (
          <div
            key={filter_item.key}
            className="current-filter-item-container"
            onClick={() => delete_filter(filter_item.key, filter_item.parent_key)}>
            <span>{filter_item.label}</span>
            <CancelIcon />
          </div>
        ))}
      </div>

      <FilterSidebar
        checkbox_change={checkbox_change}
        clear_filter={clear_filter}
        filter_list={filter_list}
        filter_open={filter_open}
        set_filter_list={set_filter_list}
        set_filter_open={set_filter_open}
        submit_filter={submit_filter}
      />

      <SortModal
        active_sort={active_sort}
        set_active_sort={set_active_sort}
        set_sort_modal={set_sort_modal}
        sort_list={sort_list}
        sort_modal={sort_modal}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  city_id: state.Login.city_id
});

export default connect(mapStateToProps)(FilterSort);
